import styled from 'styled-components';
import { PromptContainerProps } from './props';

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const PromptContainer = styled.div<PromptContainerProps>`
  position: absolute;
  z-index: 100;

  ${({ position, offset }) => {
    switch (position) {
      case 'top':
        return `
          bottom: calc(100% + ${offset}px);
          left: 50%;
          transform: translateX(-50%);
        `;
      case 'right':
        return `
          left: calc(100% + ${offset}px);
          top: 50%;
          transform: translateY(-50%);
        `;
      case 'bottom':
        return `
          top: calc(100% + ${offset}px);
          left: 50%;
          transform: translateX(-50%);
        `;
      case 'left':
        return `
          right: calc(100% + ${offset}px);
          top: 50%;
          transform: translateY(-50%);
        `;
      case 'top-left':
        return `
          bottom: calc(100% + ${offset}px);
          left: 0;
        `;
      case 'top-right':
        return `
          bottom: calc(100% + ${offset}px);
          right: 0;
        `;
      case 'bottom-left':
        return `
          top: calc(100% + ${offset}px);
          left: 0;
        `;
      case 'bottom-right':
        return `
          top: calc(100% + ${offset}px);
          right: 0;
        `;
      case 'center':
        return `
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        `;
      default:
        return `
          top: calc(100% + ${offset}px);
          left: 50%;
          transform: translateX(-50%);
        `;
    }
  }}
`;
